// extracted by mini-css-extract-plugin
export default {"secondary_btn":"index_secondary_btn__jyDNJ","btn_padding":"index_btn_padding__+LXJs"};